define('modules/layout/guide',['require','react','et_flux'],function(require) {
  var React, createComponent, div, h3, img, _ref;
  React = require("react");
  createComponent = require("et_flux").createComponent;
  _ref = React.DOM, div = _ref.div, img = _ref.img, h3 = _ref.h3;
  return createComponent("Guide", {
    propTypes: {
      data: React.PropTypes.object
    },
    render: function() {
      var data, imgURL;
      data = this.props.data;
      imgURL = "https://s3.amazonaws.com/assets.evertrue.com/global/guide/";
      return div({
        className: "guide"
      }, div({
        className: "main clearfix"
      }, div({
        className: "main-left"
      }, div({
        className: "main-screenshot-container"
      }, img({
        src: imgURL + data.img_src
      }))), div({
        className: "main-right"
      }, h3({
        className: "sub-header"
      }, data.header), div({
        className: "content main-content"
      }, data.body ? div(null, data.body) : void 0, data.media_body ? div({
        className: "media-body"
      }, data.media_body) : void 0), data.secondary_content ? div({
        className: "content secondary-content"
      }, data.secondary_content) : void 0)));
    }
  });
});

//# sourceMappingURL=guide.js.map
;
